import { debugLog, debugError } from '@utils';

class UTMParams {
  static debug = false;

  constructor() {
    this.utmParams = this.getUTMParams();
    // Prioritize the campaign and channel data over the UTM parameters and prevent race conditions in the cart update
    setTimeout(() => {
      this.#setCartAttributes(this.utmParams);
    }, 5000);
  }

  /**
   * Get UTM parameters from the URL
   * @returns {Array} - Array of UTM parameters
   */
  getUTMParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const allParams = Object.fromEntries(urlParams.entries());

    // Filter and save UTM parameters and referrer
    const utmParams = {};
    for (const [key, value] of Object.entries(allParams)) {
      if (key.toLowerCase().startsWith('utm_')) {
        utmParams[`_${key}`] = value;
      }
    }

    // Save referrer if present
    const referrer = document.referrer;
    if (referrer) {
      utmParams.referrer = referrer;
    }

    // Log the UTM parameters
    UTMParams.debug && debugLog('UTM Parameters:', utmParams);

    return utmParams;
  }

  /**
   * Set the cart attributes with the UTM parameters
   * @param {Array} data - Array of UTM parameters
   */
  async #setCartAttributes(data) {
    if (
      !data ||
      Object.keys(data).length <= 1 ||
      (Object.keys(data).length === 1 && data.referrer)
    ) {
      return;
    }
    try {
      const attributes = {
        _market: window.theme.market || null,
        _brand_id: window.theme.brandId || null,
        _language: window.theme.language || null,
        ...data,
      };

      // Set the cart attributes
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes,
        }),
      });

      if (!response.ok) {
        throw new Error('UTM Parameters: Failed to update cart attributes');
      }

      return await response.json();
    } catch (error) {
      debugError('UTM Parameters: Error setting cart attributes:', error);
      return null;
    }
  }
}

new UTMParams();
